// © Microsoft Corporation. All rights reserved.

/**
 * locationHref of page
 */
export const locationHref = (typeof(window) !== "undefined" ? window.location.href : "");

/**
 * localStorage key prefix for render cache object
 */
export const storagePrefix = `lastKnown_`;

/**
 * localStorage key prefix for render cache expiration timestamp
 */
export const expirationPrefix = `timestamp_`;

/**
 * localStorage key for JSS Map object
 */
export const jssMapKey = `${storagePrefix}jssmap`;

/**
 * localStorage key for render cache build version
 */
export const buildVersionKey = "buildVersion";

/**
 * localStorage key for render cache object
 */
export const renderCacheKey = `${storagePrefix}${locationHref}`;

/**
 * localStorage key for render cache expiration timestamp
 */
export const renderCacheExpirationKey = `${expirationPrefix}${locationHref}`;

/**
 * render-cache expiration time in ms
 * 86400000 = 24 hours in milliseconds
 */
export const defaultExpirationTimeMs = 86400000;

/**
 * River Render Cache ClassName
 */
export const riverRcClassName = "river-rc";